import DdndController from './ddnd.controller';
import Template from './ddnd.html';

export default {
    controller: DdndController,
    template: Template
};
